module.exports = __webpack_public_path__ + "media/images/application/template/arrow-up-38d642f747e0891ae19d2acd8851a893.svg";